<template>
    <div class="participants-info">
        <p class="is-size-2 has-text-weight-bold participants-info__title">Сводная информация об участниках:</p>
        <p class="participants-info__item">
            <span>Участников со статусом "Прикреплен" / "Присутствовал в подготовительный день (ПД)": </span>
            <span class="has-text-weight-bold" :class="attachedCount === approvedCount ? approvedCount === 0 ? '' : 'has-text-success' : 'has-text-warning'">
                {{attachedCount}}/{{approvedCount}} чел.
            </span>
        </p>
        <p class="participants-info__item">
            <span>Участников со статусом "Сдавал" / "Загружены результаты": </span>
            <span class="has-text-weight-bold" :class="passedCount === resultsImported ? resultsImported === 0 ? '' : 'has-text-success' : 'has-text-warning'">
                {{passedCount}}/{{resultsImported}} чел.
                <template v-if="passedCount !== resultsImported">
                    (Убедитесь, что статус "Сдавал" выставлен корректно участникам.)
                </template>
            </span>
        </p>
    </div>
</template>

<script>
import { NULL_DATE } from '../../common/data/params'
import * as participantStatuses from '@/components/common/data/participant-statuses'
export default {
  name: 'WsExamParticipantsInfo',
  props: {
    shifts: {
      type: Array,
      default () {
        return []
      }
    }
  },
  computed: {
    allParticipants () {
      const participants = []
      this.shifts.forEach(shift => {
        shift.groups.forEach(group => {
          if (group.participants) {
            group.participants.forEach(p => {
              if (!participants.some(i => i.guid === p.guid)) {
                participants.push(p)
              }
            })
          }
        })
      })
      return participants
    },
    resultsImported () {
      return this.allParticipants.filter(i => i.scaled_mark.mark100).reduce((acc, i) =>
        acc + !!(i.scaled_mark.imported_at !== NULL_DATE || i.scaled_mark.mark100 ||
        i.scaled_mark.mark500 || i.scaled_mark.mark_wsss || i.scaled_mark.medal ||
        i.scaled_mark.ranking), 0
      )
    },
    passedCount () {
      return this.allParticipants.reduce((acc, i) => acc + (i.status === participantStatuses.PASSED), 0)
    },
    attachedCount () {
      return this.allParticipants.reduce((acc, i) => acc +
      (i.status === participantStatuses.REGISTERED || i.status === participantStatuses.APPROVED || i.status === participantStatuses.PASSED), 0)
    },
    approvedCount () {
      return this.allParticipants.reduce((acc, i) =>
        acc + (i.status === participantStatuses.APPROVED || i.status === participantStatuses.PASSED), 0)
    }
  }
}
</script>

<style lang='scss' scoped>
.participants-info {
  margin: 1rem 0 1.5rem;

  &__title {
    margin-bottom: 5px;
  }

  &__item {
    padding: 10px 0;
    border-bottom: 1px solid #eee;
  }
}
</style>
